import { render, staticRenderFns } from "./ArtistResearch.vue?vue&type=template&id=174329ee&scoped=true&"
import script from "./ArtistResearch.vue?vue&type=script&lang=js&"
export * from "./ArtistResearch.vue?vue&type=script&lang=js&"
import style0 from "./ArtistResearch.vue?vue&type=style&index=0&id=174329ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174329ee",
  null
  
)

export default component.exports